import EncryptedStrings from '../constants/EncryptedStrings';
import { ApiEndpoints } from '@/api/ApiEndpoints';

const DEPLOYMENT_TYPES = {
  DEV: 'dev',
  QA: 'qa',
  STAGE: 'stage',
  PRODUCTION: 'production',
};
const environment = window.location.port === '3001' ? DEPLOYMENT_TYPES.DEV : DEPLOYMENT_TYPES.PRODUCTION

const BuildProperties = {
  deploymentType: environment,
  isProdEnv() {
    return BuildProperties.deploymentType === DEPLOYMENT_TYPES.PRODUCTION;
  },

  isDevEnv() {
    return window.location.port === '3001'
  },

  getBaseUrl() {
    switch (this.deploymentType) {
      case DEPLOYMENT_TYPES.DEV:
        return ApiEndpoints.localUrl;
      case DEPLOYMENT_TYPES.QA:
        return ApiEndpoints.qaBaseUrl;
      case DEPLOYMENT_TYPES.STAGE:
        return ApiEndpoints.stageBaseUrl;
      case DEPLOYMENT_TYPES.PRODUCTION:
        return ApiEndpoints.prodBaseUrl;
      default:
        return ApiEndpoints.qaBaseUrl;
    }
  },




  getSecretKey() {
    if (BuildProperties.isProdEnv()) {
      return EncryptedStrings.PROD_secretKeyAes;
    } else {
      return EncryptedStrings.QA_secretKeyAes;
    }
  },

  getClientHostName() {
    if (window.location.host === 'localhost:3000') {
      return 'qa-bhanix-cms.cashe.co.in';
      // return 'qa-collectiondashboard.cashe.co.in';
    } else {
      return window.location.host;
    }
  },

  getMapBoxKey() {
    if (BuildProperties.isProdEnv()) {
      return  import.meta.env.VITE_MAPBOX_ACCESS_KEY_PROD
    } else {
      return  import.meta.env.VITE_MAPBOX_ACCESS_KEY

    }
  },
};

export default BuildProperties;
